import * as React from 'react';
import Strings from '../../globals/Strings';
import Constants, {ModalStates} from '../../globals/Constants';
import EmptyStateContainer from '../EmptyState/EmptyStateContainer';
import ModalEventHandlersModel, {nullModalEventHandlersFactory} from '../../types/ModalEventHandlers';
import {TscButtonType, TscButtonTypes} from '@techsmith/tsc-cloud-style-guide';
import {MyWindow} from '../../types/MyWindow';

declare const window: MyWindow;

export default ({canCreateReviews, canStartTrial, storeUrl, setModalState}: DashboardEmptyStateProps) => {
   const title = Strings.emptyStates.dashboard.allAndOwnedTitle;
   const text = !canStartTrial && !canCreateReviews ? Strings.emptyStates.dashboard.trialExpiredMessage : Strings.emptyStates.dashboard.startReviewMessage;
   const imageSource = Constants.assetLinks.onboardingImage;

   let primaryButtonText;
   let onPrimaryClick;
   let primaryButtonType: TscButtonTypes = TscButtonType.primary;
   if (!canCreateReviews && !canStartTrial) {
      onPrimaryClick = () => window.location.assign(storeUrl);
      primaryButtonText = Strings.labels.buyButtonText;
      primaryButtonType = TscButtonType.cta;
   } else {
      const modalState = canStartTrial ? ModalStates.trialThenStartReview : ModalStates.newReview;
      onPrimaryClick = () => setModalState(modalState, nullModalEventHandlersFactory());
      primaryButtonText = Strings.labels.startReview;
   }

   return (
      <EmptyStateContainer title={title} text={text} primaryButtonText={primaryButtonText} primaryButtonType={primaryButtonType} imageSource={imageSource} onPrimaryClick={onPrimaryClick} maxWidth={Constants.dashboardEmptyStateMaxWidth} />
   );
};

export interface DashboardEmptyStateProps {
   canCreateReviews: boolean;
   canStartTrial: boolean;
   storeUrl: string;
   setModalState(modalState: ModalStates, modalEventHandlersModel: ModalEventHandlersModel): void;
}
